<template>
  <!-- BEGIN SIDEBAR -->
  <div class="page-sidebar"
       data-pages="sidebar">
    <div id="appMenu"
         class="sidebar-overlay-slide from-top">
    </div>
    <sidebar-header></sidebar-header>
    <sidebar-menu></sidebar-menu>
  </div>
  <!-- END SIDEBAR -->
</template>

<script>
  import SidebarHeader from './Header'
  import SidebarMenu from './Menu'

  export default {
    components: {
      SidebarHeader,
      SidebarMenu
    }
  }
</script>

<style scoped>
  .sidebar-header,
  .page-sidebar {
    background: #242424 !important;
    border: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// client/components/Sidebar/Sidebar.vue